/**
 * GetAppModal Component
 * Modal popup to encourage users to download the mobile app
 */

import { X } from 'lucide-react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import appStore from '../../assets/app-store.png';
import playStore from '../../assets/play-store.png';
import kahaLogo from '../../assets/Group 627737.svg';

const GetAppModal = ({ isOpen, onClose }) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modalContent = (
    <>
      {/* Backdrop */}
      <div 
        className="fixed top-0 left-0 w-screen h-screen bg-black/60 backdrop-blur-sm z-[60]"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-[70] p-4">
        <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-2xl max-w-md w-full shadow-2xl border border-green-500 relative">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:bg-white/20 p-2 rounded-lg transition-colors z-10"
          >
            <X className="w-6 h-6" />
          </button>

          {/* Content */}
          <div className="p-8 text-center">
            {/* KAHA Logo */}
            <div className="flex justify-center mb-6">
              <img src={kahaLogo} alt="KAHA" className="h-16 sm:h-20" />
            </div>

            <h2 className="font-bold text-3xl sm:text-4xl text-white mb-4">
              Get the App
            </h2>
            
            <p className="text-white/90 text-sm sm:text-base mb-8">
              Download now to book rooms and connect with hostels effortlessly.
            </p>

            {/* App Store Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
              <a
                href="https://apps.apple.com/sb/app/kaha-app/id6470139955"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-105 transition-transform"
              >
                <img src={appStore} alt="Download on App Store" className="h-12" />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.kaha_hits.kaha"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-105 transition-transform"
              >
                <img src={playStore} alt="Get it on Google Play" className="h-12" />
              </a>
            </div>

            <p className="text-white/70 text-xs">
              Available on iOS and Android
            </p>
          </div>
        </div>
      </div>
    </>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default GetAppModal;
